module.exports = __webpack_public_path__ + "static/media/bio-4@2x.3fbb6629.jpg";